import { zipCodeCityApis } from '@apis/zipCodeCityApis';
import { useQuery } from '@hooks/useQuery';

export const useZipCodeCityByZipCode = ({ zipcode }: { zipcode?: string }) => {
  return useQuery(
    ['/zipcode-city/city/{zipcode}', zipcode],
    () =>
      zipCodeCityApis
        .get('/zipcode-city/city/{zipcode}/', {
          path: { zipcode: zipcode! },
        })
        .then((r) => r['200']),
    {
      enabled: Boolean(zipcode),
    },
  );
};
